import styled, { css } from 'styled-components';

export const Card = styled.div`
  ${({
    bgColor = '#f7f7f7',
    width = '300px',
    height = '200px',
    borderColor = '#c7c7c7',
  }) => css`
    box-sizing: border-box;
    background-color: ${bgColor};
    padding: 15px;
    border: solid 1px ${borderColor};
    border-radius: 8px;
    width: ${width};
    height: ${height};
    position: relative;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  `}
`;

export const FlexCard = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  ${({
    direction = 'row',
    verticalAlignment = 'flex-start',
    horizontalAlignment = 'flex-start',
  }) => css`
    flex-direction: ${direction};
    align-items: ${direction === 'row'
      ? verticalAlignment
      : horizontalAlignment} !important;
    justify-content: ${direction === 'row'
      ? horizontalAlignment
      : verticalAlignment} !important;
  `}
`;
